import { spacing } from 'styles/spacing';
import { PageContainerStylesProps } from './page-container.types'


/** Get styles for page container */
export const getPageContainerStyles = ({ theme }: PageContainerStylesProps): string => {
  return `
    display: flex;
    flex-direction: column;
    ${spacing('px', 4)}
    width: 100%;
    max-width: 1140px;
    @media ${theme.media_queries.mediaS} {
      ${spacing('px', 6)}
    }
    @media ${theme.media_queries.mediaXXL} {
      width: 100%;
      ${spacing('px', 0)}
      margin: 0px auto;
    }
  `
}